module.exports = __webpack_public_path__ + "amex-icon@2x.png?acb4e4962da46eb0fd2318157a6dc500";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amex-icon@2x.png
// module id = 1044
// module chunks = 0